export default __webpack_public_path__ + "assets/images/4ff02de8ebb3619055a8ca7d05284d15.png";